<template>
  <div class="payStatus">
    <div class="success" v-show="showSuccess">
      <img alt :src="statusImg1" />
      <div class="success-info">
        <p id="pay">¥{{orderAmount}}</p>
        <p>您已支付成功!</p>
        <p id="order-id">订单号: {{orderNo}}</p>
      </div>
      <button @click="done">完成</button>
    </div>
    <div class="fail" v-show="showFail">
      <img alt :src="statusImg2" />
      <div class="fail-info">
        <p>抱歉，您没有支付成功</p>
        <p>请重新支付</p>
      </div>
      <button @click="repay">重新支付</button>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import api from "@/api/api.js";
export default {
  data() {
    return {
      statusImg1: api.imgAllUrl + "/sales350709.png",
      statusImg2: api.imgAllUrl + "/sales340709.png",
      shareLogo:api.imgAllUrl + "/wxLogo20210616.png",
      showSuccess:false,
      showFail:false,
      orderNo:'',
      orderAmount:''
    };
  },
  activated(){
    this.$store.commit('setShow',false)
    this.queryStatus()
  },
  methods:{
    queryStatus(){
      Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      message: '加载中',
      loadingType: 'spinner',
      mask: true
      })
      this.$http.post(api.queryOrderDetail + '?orderId=' + localStorage.getItem('ZFOrderId') + '&fileContentFlag=0')
      .then(res=>{
        Toast.clear()
        if (res.data.rtnCode === '0000') {
          this.showSuccess = true
          this.orderNo = res.data.orderNo
          this.orderAmount = res.data.orderAmount
        }else{
          this.showFail = true
          this.$toast(res.data.rtnMsg)
        }
      })
      .catch(error => {
        Toast.clear()
        console.log(error)
      })
    },
    done(){
      this.$router.push('/Order')
    },
    repay(){
       this.$http.post(api.getPaymentConfig + '?orderId=' + localStorage.getItem('ZFOrderId'))
        .then(res=>{
          window.location.href = res.data.paymentUrl + '?orderNo=' + res.data.openOrderNo + '&amount=' + res.data.payAmount + '&cc=' + res.data.channelCode
        })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./payStatus.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/payStatus/index.vue